/// ----------------------------------------------------------------------------------------
///Copyright (C) 2016 to the present, Crestron Electronics, Inc.
///All rights reserved.
///No part of this software may be reproduced in any form, machine
///or natural, without the express written consent of Crestron Electronics.
/// ----------------------------------------------------------------------------------------
/// <file>
/// <name>host.application.ts</name>
///
/// <description>
///
/// </description>
///
/// <author>Michael Martinez</author>
/// <created>15 Sept 2016</created>
///
/// <changelog>
///   Date  Who Version     Flag Comments
/// ======= === =========== ==== ===========================================================
/// 15Sep16 MM  1.0.0000         First cut
/// 23Nov16 RM  1.0.0000         Added Account actions
/// 08Feb17 YH                   Bug 117923 - Device Detail - Breadcrumbs dont appear on first click of device in tree
/// 15Mar17 YH                   Bug 122233 - Sometime a popup 'groupadd-newgroup' shows when adding a Group
/// </changelog>
///
/// </file>
/// ----------------------------------------------------------------------------------------
import { Component, AfterViewInit, ViewChild, OnInit, ElementRef, Renderer} from '@angular/core';
import { TranslatedStringsService } from './services/language.service';
import { Router, NavigationEnd, ActivationStart } from '@angular/router';
import { MediatorService } from './services/mediator.service';
import { MediatorEventLookup } from './services/mediator-event-lookup.service';
import { HydUser } from './models/user';
import { LogService } from './services/log.service';
import { SignalRService } from './services/signalR.service';
import { HydRoutingService } from './services/routing.service';
import { GroupStoreService } from './services/group-store/group-store.service';   // YH 2/8/2017 117923
import { DeviceStoreService } from './services/device-store/device-store.service';   // MM 4/10/2017
import {HostListener} from '@angular/core';
import { AzureADAccessTokenRefreshService } from './authentication/azure-active-directory/azure-ad-access-token-refresh.service';
import {PermissionsService} from './authorization/permissions/permissions.service';
import {   Feature} from './services/Crestron.HydrogenAPI.AccountApi.service';
import { XiOApplicationInsightService } from './services/xioapplicationinsight.service';

declare var Olympos: any;


@Component({
    selector: 'host-app',
    templateUrl: './host.application.html'
})
export class HostApplication implements AfterViewInit {
    private name: string;
    private previousName: string;
    private trackTimeSpentStart: Date;

    constructor(
        private hydUser: HydUser,
        private _log: LogService,
        private i18n: TranslatedStringsService,
        private _mediator: MediatorService,
        private _router: Router,
        private signalRService: SignalRService,
        private _hydRoutingService: HydRoutingService,
        private mediator: MediatorService,
        private groupStoreService: GroupStoreService,  // YH 2/8/2017 117923
        private deviceStoreService: DeviceStoreService, // MM 4/10/2017
        private _AADAccessTokenRefresh: AzureADAccessTokenRefreshService, //YH 5/9/2017 Bug 129033,
        private elementRef: ElementRef,
        private renderer: Renderer,
        private permissionsService: PermissionsService,
        private xioApplicationInsightService: XiOApplicationInsightService
    ) {
        _router.events.subscribe((val) => {

            if (val instanceof ActivationStart) {
                if (val.snapshot.data.feature && val.snapshot.data.feature != "") {
                    this.name = val.snapshot.data['feature']; // To get data from route
                    if (this.previousName && (this.previousName != this.name)) { //To ignore left list change and capture only tab views
                        var duration = new Date().getTime() - this.trackTimeSpentStart.getTime();
                            xioApplicationInsightService.logMetric('Time Spent on ' + this.previousName, duration);
                        }
                    }
                else if (val.snapshot.component) {
                    console.log('Missing feature-id for ' + val.snapshot.component['name']);
                }
            }

            if (val instanceof NavigationEnd) {
                let baseUrl = window.location.protocol + "//" + window.location.host;
                if (this.name && (this.previousName != this.name)) { //To ignore left list change and capture only tab views
                    xioApplicationInsightService.logPageView(this.name, baseUrl + val.url);
                }
                this.previousName = this.name;
                this.trackTimeSpentStart = new Date();
            }
        });
    }

    //----------------------------------------------------------
    //ngOnInit
    //----------------------------------------------------------
    ngOnInit() {
        //YH 3/15/2017 Bug 122233
        //HostApplication should not show any locale strings as it is outside the router TranslatedStringsResolver.
        //HostApplication should not contain any html code except components that are places under router guards and resolvers
        //
        // this.i18n.init().then((response) => {
        //     this.translate();
        // });
        this.start();

    }


    //----------------------------------------------------------
    //ngAfterViewInit
    //----------------------------------------------------------
    ngAfterViewInit() {
      Olympos.init();
      Olympos.toggleMenu();
    }

     //----------------------------------------------------------
    //start
    //----------------------------------------------------------
    private start() {

      this._AADAccessTokenRefresh.resetRefreshTimer();

        // YH 2/8/2017 117923
        this.groupStoreService.Start();
        this.deviceStoreService.Start();
        this.permissionsService.Start();

        if (this.hydUser.UserId == null) {
            this.hydUser.AuthenticationObservable.subscribe(user => {
                //document.getElementById("menu-resize-btn").style.visibility = "visible";
                document.getElementById("usr-info").style.visibility = "visible";
            });
        } else {

            //document.getElementById("menu-resize-btn").style.visibility = "visible";
            document.getElementById("usr-info").style.visibility = "visible";
        }


        let container = this.elementRef.nativeElement.querySelector('#layout-container');
        if (container) {
            this.renderer.setElementStyle(container, 'background-color', '#F2F2F2');
        }


    }

    //----------------------------------------------------------
    //onLogoClick
    //----------------------------------------------------------
    private onLogoClick(): void {

        this.mediator.Action(MediatorEventLookup.HydrogenLogoClicked, "");
    }

     //----------------------------------------------------------
    //toggleSignout
    //----------------------------------------------------------
    private toggleSignout(event) : void {
        this.mediator.Action(MediatorEventLookup.LogoutDialogToggle, event);
  }

  //----------------------------------------------------------
  //toggleDashboard
  //----------------------------------------------------------
  private toggleDashboard(event): void {
    this.mediator.Action(MediatorEventLookup.ShowDashboardToggle, event);
  }


    //----------------------------------------------------------
    //keyDown
    //----------------------------------------------------------
    @HostListener('window:keydown', ['$event'])
    private keyDown(event: KeyboardEvent): void {

        if (event.altKey && event.ctrlKey && event.shiftKey) {
            this.mediator.Action(MediatorEventLookup.DebugModeToggle, "");
        }

    }

}



// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/host.application.ts